module.exports = __webpack_public_path__ + "img/white_rook.5abb68d3.png";